/* eslint-disable no-unused-vars */
import { h, render, Fragment } from 'preact';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/navigation';
import 'swiper/css';
import clsx from 'clsx';
import Image from '../utils/image';
import { hasRichTextContent } from '../utils/helpers';
import IconArrowRight from '../utils/icon/arrow-right.svg';
import IconArrowLeft from '../utils/icon/arrow-left.svg';
import './product-press-slider.css';

export default (element, data) => {
  const init = () => {
    render(<ProductPressSlider />, element);
  };

  const slidesWithContent = data.slides.filter((slide) => 
    !!slide.image || !!slide.overview || hasRichTextContent(slide.overviewRich)
  );

  const slideCount = slidesWithContent.length;

  const setSlidesCountSettings = () => {
    if (slideCount > 1 && slideCount <= 3) {
      const settings = {
        navigation: { prevEl: '.prev', nextEl: '.next' },
        slidesPerView: 'auto',
        breakpoints: {
          320: {
            navigation: { prevEl: '.prev', nextEl: '.next' },
            slidesPerView: 'auto',
          },
          1024: {
            slidesPerView: slideCount
          },
        },
      };
      return settings;
    }

    return {
      navigation: { prevEl: '.prev', nextEl: '.next' },
      slidesPerView: 'auto',
    };
  };

  const ProductPressSlider = () => {
    const slides = setSlidesCountSettings();

    return slideCount < 1 ? null : (
      <>
        <div className={'bg-cream-grey pb-10 laptop:pb-[76px] '}>
          <div
            className={
              'relative pt-[45px] laptop:pt-20 pb-4 laptop:pb-5 flex align-center justify-between px-5 laptop:px-10'
            }
          >
            <h3 className={'subheading-h2 flex items-center'}>{data.title}</h3>
            <div>
              <button
                className={
                  'prev navigation-arrow bg-transparent  border border-[#0000004d] rounded-full inline-flex mr-[10px]'
                }
              >
                <IconArrowLeft />
              </button>
              <button
                className={
                  'next navigation-arrow bg-transparent border border-[#0000004d] rounded-full inline-flex'
                }
              >
                <IconArrowRight />
              </button>
            </div>
          </div>

          <div
            className={clsx(
              slideCount > 1 && slideCount < 4 && 'laptop:mr-10',
              slideCount === 1 && 'laptop:mr-10 mr-5',
              'border border-[#C1BEB9] ml-5 laptop:ml-10',
            )}
          >
            <Swiper modules={[Navigation]} {...slides}>
              {slidesWithContent.map((slide, index) => (
                <SwiperSlide
                  key={slide.id}
                  className={clsx(
                    slideCount < 4 && 'w-custom-20',
                    slideCount >= 3 && 'w-custom-20-3',
                    slideCount - 1 !== index && 'border-r border-[#C1BEB9]',
                  )}
                >
                  <div
                    className={
                      'p-10 desktop:p-[60px] flex flex-col justify-center min-h-[375px]'
                    }
                  >
                    {slide.image && (
                      <div
                        className={clsx(
                          'flex align-center justify-center',
                          (slide.overview || hasRichTextContent(slide.overviewRich)) && 'laptop:mb-[35px] mb-6',
                        )}
                      >
                        <Image
                          src={slide.image}
                          classes={
                            'object-contain w-[131px] h-8 laptop:w-[164px] laptop:h-10'
                          }
                        />
                      </div>
                    )}
                    {(slide.overviewRich || slide.overview) && (
                      <>
                        {slide.overviewRich ? (
                          <div
                            className={
                              'max-w-[557px] text-center mx-auto subheading-h4 rte'
                            }
                            dangerouslySetInnerHTML={{
                              __html: slide.overviewRich,
                            }}
                          ></div>
                        ) : (
                          <div
                            className={
                              'max-w-[557px] text-center mx-auto subheading-h4'
                            }
                          >
                            {slide.overview}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </>
    );
  };

  init();
};
